import * as React from "react";

const SvgIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="36"
    height="36"
    fill="none"
    viewBox="0 0 36 36">
    <circle cx="18" cy="18" r="18" fill="#37B34A"></circle>
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M26.335 18.001c0 4.6-3.734 8.334-8.334 8.334A8.336 8.336 0 0 1 9.668 18c0-4.6 3.733-8.333 8.333-8.333s8.334 3.733 8.334 8.333"></path>
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="m21.091 20.65-2.583-1.542c-.45-.267-.817-.909-.817-1.434v-3.416"></path>
  </svg>
);

export default SvgIcon;
